import { CourseOfStudyDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCourseOfStudy = createAction(
  '[CourseOfStudy] Load CourseOfStudy'
);

export const loadCourseOfStudySuccess = createAction(
  '[CourseOfStudy] Load CourseOfStudy Success',
  props<{ courseofstudy: CourseOfStudyDto[] }>()
);

export const loadCourseOfStudyFailure = createAction(
  '[CourseOfStudy] Load CourseOfStudy Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCourseOfStudy = createAction(
  '[CourseOfStudy] Add CourseOfStudy',
  props<{ newCourseOfStudy: CourseOfStudyDto[] }>()
);

export const addCourseOfStudySuccess = createAction(
  '[CourseOfStudy] Add CourseOfStudy Success',
  props<{ newCourseOfStudy: CourseOfStudyDto[] }>()
);

export const addCourseOfStudyFailure = createAction(
  '[CourseOfStudy] Add CourseOfStudy Failure',
  props<{ error: any }>()
);

/**
 * Update CourseOfStudy Collection Actions
 */
export const updateCourseOfStudy = createAction(
  '[CourseOfStudy] Update CourseOfStudy',
  props<{ updateCourseOfStudy: CourseOfStudyDto[] }>()
);

export const updateCourseOfStudySuccess = createAction(
  '[CourseOfStudy] Update CourseOfStudy Success',
  props<{ updateCourseOfStudy: CourseOfStudyDto[] }>()
);

export const updateCourseOfStudyFailure = createAction(
  '[CourseOfStudy] Update CourseOfStudy Failure',
  props<{ error: any }>()
);

/**
 * Remove CourseOfStudy Collection Actions
 */
export const removeCourseOfStudy = createAction(
  '[CourseOfStudy] Remove CourseOfStudy',
  props<{ ids: string[] }>()
);

export const removeCourseOfStudySuccess = createAction(
  '[CourseOfStudy] Remove CourseOfStudy Success',
  props<{ ids: string[] }>()
);

export const removeCourseOfStudyFailure = createAction(
  '[CourseOfStudy] Remove CourseOfStudy Failure',
  props<{ error: any }>()
);
